module.exports = __webpack_public_path__ + "img/icone-06.svg";